import type { DadataSuggestion } from "@/stores/ContractorDetailStore/legal-store/LegalDataSubStore";

export function TwoLineSuggestionDropdown({
  suggestions,
  visible,
  onSelect,
  getName,
  getMeta,
}: {
  suggestions: DadataSuggestion[];
  visible: boolean;
  onSelect: (s: DadataSuggestion) => void;
  getName: (s: DadataSuggestion) => string;
  getMeta: (s: DadataSuggestion) => string;
}) {
  if (!visible || suggestions.length === 0) return null;
  return (
    <div className="scd-drawer-suggestions">
      {suggestions.map((s, i) => (
        <button
          key={i}
          type="button"
          className="scd-drawer-suggestion scd-drawer-suggestion--two-line"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(s);
          }}
        >
          <span className="scd-drawer-suggestion__name">{getName(s)}</span>
          <span className="scd-drawer-suggestion__meta">{getMeta(s)}</span>
        </button>
      ))}
    </div>
  );
}
